var React = require('react');

function QuoteCircle (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n\t\t.quote-circle-lg { fill: none;stroke: #56bbb1;stroke-width: 4 } \n\t\t.quote-sircle-sm { fill: none;stroke: #56bbb1;stroke-width: 2 } \n\t"),React.createElement("circle",{"id":"largeC","className":"quote-circle-lg","cx":"267","cy":"267","r":"261","key":1}),React.createElement("circle",{"id":"smallC","className":"quote-sircle-sm","cx":"267","cy":"267","r":"249","key":2})]);
}

QuoteCircle.defaultProps = {"version":"1.2","viewBox":"0 0 534 534","width":"534","height":"534"};

module.exports = QuoteCircle;

QuoteCircle.default = QuoteCircle;
